// src/forms/NameChangeForm.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Form.css';
import { toFullWidthKatakana, furiganaToFullWidth } from '../lib/kanaNormalize';
import { requiredFieldClass } from '../lib/requiredFieldClass';

const DRAFT_KEY = 'draft_name_change';

const NameChangeForm = ({ onBack, onNext, isFirstForm, isLastForm, isMultiForm, id, isDraft }) => {
    //  フォームを管理するための状態
    const [formData, setFormData] = React.useState({
        oldName: '',
        newName: '',
        oldKanaName: '',
        newKanaName: ''
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const isComposing = useRef(false);

    React.useEffect(() => {
        {/*}
        const eid = localStorage.getItem('memberId');
        if (eid) {
	     setFormData(prev => ({ ...prev, memberId: eid }));
	      return;
	    }
        */}
     // なければ /api/me で取得して保存
      (async () => {
      try {
        const me = await api.get('/api/me/');   // Authorization は api.js が付与
        console.log("ME API RESPONSE:", me.data);
        
        if (me?.data?.memberId) {
          localStorage.setItem('memberId', me.data.memberId);
          setFormData(prev => ({ 
            ...prev,
            memberId: me.data.memberId,
            oldName: me.data.name || '',       
            oldKanaName: me.data.kanaName || '', 
          }));
        } else {
          alert('エラー: 社員番号が取得できませんでした。再度ログインしてください。');
          navigate('/m/login');
        }
      } catch (e) {
        alert('エラー: 認証が切れています。再度ログインしてください。');
        navigate('/m/login');
      }
    })();
    }, [navigate]);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(DRAFT_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                setFormData(prev => ({ ...prev, newName: parsed.newName || '', newKanaName: parsed.newKanaName || '' }));
            }
        } catch (_) {}
    }, []);

    const handleSaveDraft = () => {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ newName: formData.newName, newKanaName: formData.newKanaName }));
        alert('一時保存しました。');
    };

    const handleDeleteDraft = async () => {
        const confirmDelete = window.confirm("この下書き（一時保存データ）を削除してもよろしいですか？\n※削除すると元に戻せません。");
        if (!confirmDelete) return;

        setLoading(true);
        try {
            if (id) {
                await api.delete(`/api/applications/drafts/${id}/`);
            }
            // ローカルでも削除
            localStorage.removeItem(DRAFT_KEY);
            alert('下書きを削除しました。');
            navigate('/applications');
        } catch (error) {
            console.error('下書きの削除に失敗:', error);
            alert('下書きの削除に失敗しました。もう一度お試しください。');
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        if (onBack) onBack();
        else navigate('/applications');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'newKanaName') {
            if (isComposing.current) {
                setFormData(prevData => ({ ...prevData, [name]: value }));
                return;
            }
            const kata = toFullWidthKatakana(furiganaToFullWidth(value));
            const katakanaOnly = kata.replace(/[^\u30A0-\u30FFー・\s]/g, '');
            setFormData((prevData) => ({
                ...prevData,
                [name]: katakanaOnly,
            }));
            return;
        }
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleCompositionEnd = (e) => {
        isComposing.current = false;
        setTimeout(() => handleInputChange(e), 50);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const katakanaPattern = /^[\u30A0-\u30FFー・\s]*$/;
        if (formData.newKanaName && !katakanaPattern.test(formData.newKanaName)) {
            alert('新氏名（フリガナ）にはカタカナのみ入力してください。');
            return;
        }
        const isConfirmed = window.confirm("名前変更申請を送信してもよろしいですか？");
    
        if (!isConfirmed) {
            return; 
        }

        // ユーザーのUUIDが取得できているか確認
        if (!formData.memberId) {
            alert('エラー: 申請者の識別子が取得できていません。再ログイン後にお試しください。');
            return;
        }

        const submissionData = {
            //title: '名前変更届',
            //category: 'NAME_CHANGE',
            //applicant: formData.employeeId, // UUIDをバックエンドに送信
            //content: JSON.stringify({
            oldName: formData.oldName,
            oldKanaName: formData.oldKanaName,
            newName: formData.newName,
            newKanaName: formData.newKanaName,
            
        };

        try {
            await api.post('/api/forms/submit_name_change/', submissionData);
            localStorage.removeItem(DRAFT_KEY);
            alert('名前変更届が正常に提出されました。');
            navigate('/applications');
        } catch (error) {
            console.error('Submission failed:', error.response ? error.response.data : error.message);
            alert('申請に失敗しました。もう一度お試しください。');
            
        }
    };
    
   
    return (
        <div className="container form-container">
            <h3>名前変更届</h3>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="oldName" className="form-label">旧氏名</label>
                    <input type="text" id="oldName" name="oldName" className="form-control" value={formData.oldName} readOnly />
                </div>
                <div className="mb-3">
                    <label htmlFor="oldKanaName" className="form-label">旧氏名（フリガナ）</label>
                    <input type="text" id="oldKanaName" name="oldKanaName" className="form-control" value={formData.oldKanaName} readOnly />
                </div>
                <div className="mb-3">
                    <label htmlFor="newName" className="form-label">新氏名</label>
                    <input type="text" id="newName" name="newName" className={requiredFieldClass(formData.newName)} value={formData.newName} onChange={handleInputChange} required />
                </div>
                
                <div className="mb-3">
                    <label htmlFor="newKanaName" className="form-label">新氏名（フリガナ）</label>
                    <input
                        type="text"
                        id="newKanaName"
                        name="newKanaName"
                        className={requiredFieldClass(formData.newKanaName)}
                        value={formData.newKanaName}
                        onChange={handleInputChange}
                        onCompositionStart={() => { isComposing.current = true; }}
                        onCompositionEnd={handleCompositionEnd}
                        required
                        placeholder="カタカナで入力"
                    />
                </div>
                
            
            <div className="button-group">
                <button type="submit" className="btn-submit">申請</button>
                <button type="button" className="btn-draft" onClick={handleSaveDraft}>一時保存</button>
                {((id && isDraft) || localStorage.getItem(DRAFT_KEY)) && <button type="button" className="btn-delete-draft" onClick={handleDeleteDraft} disabled={loading}>下書削除</button>}
                <button type="button" className="btn-back" onClick={handleBack}>{onBack && !isFirstForm ? '前へ' : '戻る'}</button>
                {isMultiForm && onNext && <button type="button" className="btn-nav" onClick={onNext}>{isLastForm ? '完了' : '次へ'}</button>}
            </div>
            </form>
        </div>
    );
};

export default NameChangeForm;